import { useLayoutEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IUpdatePersonalDetails } from 'Interfaces/updatePersonalDetails';
import { getContactDetailsSchema } from 'Modules/Requests/UpdatePersonalDetails/Schema';
import { useAppSelector } from './useAppSelector';
import { IPhones } from 'API/personalDetails';

const contactDetailsDirtyStateInit = {
  phonePrefix: false,
  phoneNumber: false,
  extraPhoneNumber: false,
  extraPhonePrefix: false,
};
export const useContactDetailsForm = () => {
  const [contactDetailsDirtyState, setContactDetailsDirtyState] = useState<
    typeof contactDetailsDirtyStateInit
  >({ ...contactDetailsDirtyStateInit });

  const personalDetails = useAppSelector(
    ({ personalDetails: { personalDetails } }) => personalDetails
  );

  let defaultMobilePhoneIndex: number;
  let defaultMobilePhone: IPhones | undefined;
  let defaultExtraPhone: IPhones | undefined;
  let defaultEmail: string | undefined;
  if (personalDetails?.phones && personalDetails.phones.length > 0) {
    defaultMobilePhone = personalDetails?.phones?.find(
      (phone: IPhones, index: number) => {
        if (phone.phoneType === 3) {
          defaultMobilePhoneIndex = index;
          return true;
        }
        return false;
      }
    );
    defaultEmail = personalDetails?.phones?.find(
      (phone: IPhones) => phone.email && phone.email !== ''
    )?.email;
  }
  if (personalDetails?.phones && personalDetails.phones.length > 1)
    defaultExtraPhone = personalDetails?.phones.find(
      (phone: IPhones, index: number) => index !== defaultMobilePhoneIndex
    );

  const contactDetailsForm = useForm<IUpdatePersonalDetails['contactDetails']>({
    mode: 'onBlur',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(
      getContactDetailsSchema(contactDetailsDirtyState) as any
    ),
    defaultValues: {
      phonePrefix: defaultMobilePhone?.prefixId || -1,
      phoneNumber: defaultMobilePhone?.phoneNum || '',

      extraPhonePrefix: defaultExtraPhone?.prefixId || -1,
      extraPhoneNumber: defaultExtraPhone?.phoneNum || '',
      email: defaultEmail || '',
    },
  });

  useLayoutEffect(() => {
    setContactDetailsDirtyState({
      phoneNumber:
        contactDetailsForm.formState.dirtyFields.phoneNumber || false,
      phonePrefix:
        contactDetailsForm.formState.dirtyFields.phonePrefix || false,
      extraPhoneNumber:
        contactDetailsForm.formState.dirtyFields.extraPhoneNumber || false,
      extraPhonePrefix:
        contactDetailsForm.formState.dirtyFields.extraPhonePrefix || false,
    });
  }, [
    contactDetailsForm.formState.dirtyFields.extraPhoneNumber,
    contactDetailsForm.formState.dirtyFields.extraPhonePrefix,
    contactDetailsForm.formState.dirtyFields.phoneNumber,
    contactDetailsForm.formState.dirtyFields.phonePrefix,
    personalDetails,
  ]);

  return contactDetailsForm;
};
